import { render, staticRenderFns } from "./VerticalMonitoring.vue?vue&type=template&id=565be6ec&scoped=true"
import script from "./VerticalMonitoring.vue?vue&type=script&lang=js"
export * from "./VerticalMonitoring.vue?vue&type=script&lang=js"
import style0 from "./VerticalMonitoring.vue?vue&type=style&index=0&id=565be6ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565be6ec",
  null
  
)

export default component.exports